import { createSlice } from '@reduxjs/toolkit';
import { getAllActiveWinners } from './winnerServices';

const initialState = {
    allActiveWinners: {
        isWinnersLoading: null,
        isWinnersSuccess: null,
        bannerMessage: null,
        pageCount: null,
        winners: []
    }
}

const winnerSlice = createSlice({
    name: 'winner',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllActiveWinners.pending, (state) => {
            state.allActiveWinners = {
                ...initialState.allActiveWinners,
                isWinnersLoading: true,
                bannerMessage: 'Loading winners...'
            };
        })
        .addCase(getAllActiveWinners.rejected, (state, action) => {
            state.allActiveWinners = {
                ...initialState.allActiveWinners,
                isWinnersLoading: false,
                isWinnersSuccess: false,
                bannerMessage: action.payload
            };
        })
        .addCase(getAllActiveWinners.fulfilled, (state, action) => {
            state.allActiveWinners = {
                ...initialState.allActiveWinners,
                isWinnersLoading: false,
                isWinnersSuccess: true,
                bannerMessage: action.payload.message,
                winners: action.payload.data,
                pageCount: action.payload.pageCount
            };
        })
    }
});

export default winnerSlice.reducer;